<template>
  <div class="datefield">
    {{ formattedDate }}
  </div>
</template>

<script>
export default {
  name: 'tablefield-date',
  props: ['data', 'config'],
  computed: {
    formattedDate() {
      return this.$options.filters.date(this.data, this._.get(this.config, 'format'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldDate.vue?756f6698